import { render, staticRenderFns } from "./userDepartment.vue?vue&type=template&id=ad83d1b4&scoped=true"
import script from "./userDepartment.vue?vue&type=script&lang=js"
export * from "./userDepartment.vue?vue&type=script&lang=js"
import style0 from "./userDepartment.vue?vue&type=style&index=0&id=ad83d1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad83d1b4",
  null
  
)

export default component.exports